import Image from "next/image"
import { Chip, Container, Stack } from "@octopus-energy/coral/atoms"
import { useTranslations } from "next-intl"
import { css } from "@octopus-energy/coral-design/css"

export function InvoiceUploadNewChip() {
    const t = useTranslations("InvoiceUploadNewChip")

    return (
        <div
            className={css({
                position: "absolute",
                right: "14px",
                top: "-12px",
                zIndex: "100",
            })}
        >
            <Stack justifyContent="flex-end">
                <Chip
                    color="tertiary500"
                    size="small"
                >
                    <Container
                        paddingX="xs"
                        paddingY="none"
                    >
                        <Stack
                            gap="xxs"
                            alignItems="center"
                        >
                            <Image
                                src="/assets/images/illustrations/ai-stars.svg"
                                alt={t("imgAlt")}
                                width={16}
                                height={16}
                            />
                            {t("new")}
                        </Stack>
                    </Container>
                </Chip>
            </Stack>
        </div>
    )
}

InvoiceUploadNewChip.messages = ["InvoiceUploadNewChip"] as const
